import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const formatDate = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
};

export const formatDateTime = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};

export const formatCurrency = (amount, currency = 'USD') => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency
  }).format(amount);
};

export const getStatusColor = (status) => {
  const colors = {
    pending: 'bg-yellow-100 text-yellow-800',
    confirmed: 'bg-green-100 text-green-800',
    in_transit: 'bg-blue-100 text-blue-800',
    delivered: 'bg-green-100 text-green-800',
    cancelled: 'bg-red-100 text-red-800'
  };
  return colors[status] || 'bg-gray-100 text-gray-800';
};

export const containerTypes = [
  { value: '20ft', label: "20' Standard" },
  { value: '40ft', label: "40' Standard" },
  { value: '40ft_hc', label: "40' High Cube" },
  { value: '20ft_reefer', label: "20' Reefer" },
  { value: '40ft_reefer', label: "40' Reefer" }
];

export const cargoTypes = [
  { value: 'FCL', label: 'Full Container Load (FCL)' },
  { value: 'LCL', label: 'Less than Container Load (LCL)' }
];

// Filename from a Content-Disposition header (e.g. BL_SDVU48291173.pdf), else the fallback.
export const attachmentFilename = (response, fallback) => {
  const match = /filename="?([^";]+)"?/.exec(response?.headers?.['content-disposition'] || '');
  return match ? match[1] : fallback;
};

export const PACKAGE_TYPES = ['CARTONS', 'PALLETS', 'BAGS', 'BALES', 'BUNDLES', 'COILS', 'CRATES', 'CASES', 'DRUMS', 'ROLLS', 'PIECES', 'UNITS', 'IN BULK'];
